var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPointer2Jack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 108.073,
    height: 11.498,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#707070"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u7DDA 152",
    fill: "none",
    strokeWidth: 3,
    d: "M.073 1.498l103 5"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\u6955\\u5186\\u5F62 30",
    transform: "translate(98.073 1.498)",
    fill: "#707070",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 5,
    r: 5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 5,
    r: 4,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPointer2Jack);
export default __webpack_public_path__ + "static/media/pointer2Jack.363eec473e373758.svg";
export { ForwardRef as ReactComponent };